import { autoinject, transient } from "aurelia-dependency-injection";
import { BindingEngine, type Disposable } from "aurelia-framework";
import { AdornerService } from "../../services/basic/adorner.service";
import { AdornerModel } from "./comp-adorner.models";

//Load styles
require("./comp-adorner.scss");

@autoinject
@transient()
export class CompAdorner {

    private _subscriptions: { model: AdornerModel, subscription: Disposable }[] = [];

    models: AdornerModel[] = [];

    constructor(adornerService: AdornerService, private bindingEngine: BindingEngine) {
        adornerService.onAdd((model) => {
            if (model.context && model.element && model.html) {
                this.models.push(model);
                this._subscriptions.push({
                    model: model,
                    subscription: this.bindingEngine.propertyObserver(model.context, 'isDropdownOpen').subscribe(() => {
                        if (model.context.isDropdownOpen) {
                            model.setStyleString();
                        }
                    })
                });
            }
        });

        adornerService.onRemove((model) => {
            const index = this.models.indexOf(model);
            if (index >= 0) {
                this.models.splice(index, 1);

                const subIndex = this._subscriptions.findIndex(x => x.model == model);
                this._subscriptions.splice(subIndex, 1);
            }
        });

        setInterval(() => {
            for (const item of this.models.filter(x => x.context.isDropdownOpen)) {
                item.setStyleString();
            }
        }, 120);
    }
}

